/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import MainNavDumb from './MainNavDumb';
import {
  getBackToAppURL,
  getBackToAppLabel,
  getBackToAppIcon,
} from 'plugin/back-to-app/util/backToAppUtils';
import { getCustomMenuLinks } from 'plugin/custom-menu/util/customMenuUtils';
import withFeatureDecisions from 'src/shared/app/feature/component/withFeatureDecisions';
import { getBraindateNotificationCount } from 'src/shared/app/notification/selector/appNotificationSelectors';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';
import { defaultLocale } from 'src/shared/app/locale/settings/localeSettings';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  featureDecisions: Object,
};

const mapStateToProps = (state: State, { featureDecisions }: Props): Object => {
  const externalLinks = [];
  const user = getSelf(state);

  const locale = (user ? user.language : '') || defaultLocale;
  const event = getEventSafely(state);

  if (featureDecisions.hasBackToAppLink()) {
    const externalLink = getBackToAppURL(event);
    const externalLabel = getBackToAppLabel(event);
    const externalIcon = getBackToAppIcon(event);

    externalLinks.push({
      href: externalLink,
      body: { [locale]: { label: externalLabel } },
      icon: externalIcon,
      target: '_self',
    });
  }

  if (featureDecisions.hasCustomMenu()) {
    const links = getCustomMenuLinks(event) || [];
    links.forEach((link) => externalLinks.push(link));
  }

  return {
    externalLinks,
    user,
    hasBraindateNotifications: !!getBraindateNotificationCount(state),
  };
};

export default compose(
  withFeatureDecisions,
  connect(mapStateToProps),
)(MainNavDumb);
